import { useInfiniteQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useSearchChannelPosts = () => {
  const infiniteQuery = (keyword: string) => {
    return useInfiniteQuery({
      queryKey: ['channel_posts', keyword],
      queryFn: ({ pageParam }) => _a.searchChannelPosts({ keyword, page: pageParam, per: 30 }),
      initialPageParam: 1,
      getNextPageParam: (resp) => {
        if (resp.has_next) {
          return resp.page + 1;
        } else {
          return undefined;
        }
      },
    });
  };

  return { infiniteQuery };
};
